export default __webpack_public_path__ + "static/media/LEGAL-1.6ce9075d.jpg";